module.exports = __webpack_public_path__ + "img/userLogo19.bdff85b1.jpg";